// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__XL8nA","col":"CardReaderDesc_col__3exbP","label":"CardReaderDesc_label__pSg1j"};